import {
  appendThirdPartyScriptsSync,
  handleScriptEqualWeb,
} from './src/helpers/partners/thirdPartyScripts';
import { setCookieTracking } from './src/helpers/setCookieTracking';
import './src/styles/global.css';

export const onInitialClientRender = () => {
  setCookieTracking('queryParamsSitePartners');
  appendThirdPartyScriptsSync();

};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (process.env.NODE_ENV === 'production') {
    handleScriptEqualWeb({
      pathname: location.pathname,
      prevPathname: prevLocation?.pathname,
    });
  }
};

